import {
    React, RouteComponentProps,
    Formsy, form, formHelpers,
    i18n,
    observable, inject, observer,
    mui, ui, theme, styled, pr,
    api, apiClient,
    debug
} from "aaa";

import { Auth } from "models/Auth";
import * as _ from "lodash";
import { Link } from "react-router-dom";



type IProps = RouteComponentProps<{}> & i18n.InjectedIntlProps & {
    auth: Auth
};


@i18n.injectIntl
@inject("auth")
@observer
export class RequestPassword extends React.Component<IProps, {}> {

    @observable
    formIsValid = true;


    onSubmit = async (fields: any, resetForm: any, invalidateForm: any) => {
        const request = api.requestPassword(fields.email);
        try {
            const response = await apiClient.requestType(request);
            ui.showMessageBox({
                title: ui.__("password"),
                message: ui.__("password.requestSent"),
                onOk: () => { this.props.history.push("/login"); }
            });
        } catch (error) {
            ui.showGenericError(error.statusCode);
        }
    }

    render() {
        return (
            <div style={{ padding: theme.MARGIN_BIG }}>
                <Formsy.Form
                    onValidSubmit={this.onSubmit}
                    onValid={() => { this.formIsValid = true; }}
                    onInvalid={() => { this.formIsValid = false; }}
                >
                    <form.FormsyText
                        name="email"
                        required={true}
                        validations="isEmail"
                        floatingLabelText={ui.__("emailAddress")}
                        fullWidth={true}
                        validationError={ui.__("error.emailInvalid")}
                    />

                    <br /><br />
                    {formHelpers.renderActionButton(ui.__("header.requestPassword"))}
                </Formsy.Form>
            </div >
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/RequestPassword.tsx